import {
  REQUEST_GIFT_PURCHASE,
  RECEIVE_GIFT_PURCHASE,
  REQUEST_PURCHASED_GIFTS,
  RECEIVE_PURCHASED_GIFTS,
  HIDE_GIFT_NOTIFCATION,
  GIVE_A_GIFT,
  MONETIZE_GIFT,
  giftTypes
} from './shopActions'
import { LOG_OUT } from '../../top-panel/authorized-controls/authorizationActions'

const initialState = {
  gifts: undefined,
  boughtGifts: undefined,
  isLoading: false,
  notification: undefined
}

export default (
  state = initialState,
  action
) => {
  switch (action.type) {
    case REQUEST_GIFT_PURCHASE:
      return { ...state, isLoading: true }

    case RECEIVE_GIFT_PURCHASE:
      const newGifts = [...state.gifts]
      const giftTypeIndex = state.gifts.findIndex(g => g.id === action.giftId)

      if (giftTypeIndex !== -1) { // if there's already an object with this ID => increase its amount by 1
        newGifts[giftTypeIndex] = { ...newGifts[giftTypeIndex], amount: newGifts[giftTypeIndex].amount + 1 }
      } else { // if no => create new with number === 1
        newGifts.push({ id: action.giftId, amount: 1 })
      }

      return { gifts: newGifts, isLoading: true, notification: action.giftId }

    case HIDE_GIFT_NOTIFCATION:
      return { ...state, isLoading: false, notification: undefined }

    case REQUEST_PURCHASED_GIFTS:
      return { gifts: undefined, isLoading: true, notification: undefined }

    case RECEIVE_PURCHASED_GIFTS:

      return { gifts: action.gifts, isLoading: false, notification: undefined }
    case GIVE_A_GIFT:
      const boughtGifts = state.gifts.filter(item => (item.id === action.giftId && item.giftType === giftTypes.bought))
      const giftType = (boughtGifts.length !== 0) ? giftTypes.bought : giftTypes.received
      return {
        ...state,
        gifts: state.gifts.map(item => (item.id === action.giftId && item.giftType === giftType)
          ? { id: item.id, amount: item.amount - 1 } : item)
      }
    case MONETIZE_GIFT:
      return {
        ...state,
        gifts: state.gifts.map(item => (item.id === action.giftId && item.giftType === giftTypes.received)
          ? { id: item.id, amount: item.amount - 1 } : item)
      }
    case LOG_OUT:
      return { ...initialState }
    default: return state
  }
}
